export const ADMIN_CAPABILITIES = Object.freeze({
  ACCESS: 'admin:access',
  PROVISION: 'admin:provision',
  USERS_MANAGE: 'users:manage',
  GROUNDS_MANAGE: 'grounds:manage',
  MATCHES_MANAGE: 'matches:manage',
  BOOKINGS_MANAGE: 'bookings:manage',
  PAYMENTS_READ: 'payments:read',
  PAYMENTS_MANAGE: 'payments:manage',
  PROMOTIONS_MANAGE: 'promotions:manage',
  SPORTS_MANAGE: 'sports:manage',
  ACADEMIES_MANAGE: 'academies:manage',
  EXPORTS_READ: 'exports:read',
  PREMIUM_READ: 'premium:read',
  PREMIUM_PLANS_MANAGE: 'premium:plans:manage',
  PREMIUM_BENEFITS_MANAGE: 'premium:benefits:manage',
  PREMIUM_SUBSCRIPTIONS_ADJUST: 'premium:subscriptions:adjust',
  PREMIUM_RECONCILIATION_RUN: 'premium:reconciliation:run',
  PREMIUM_REPORTS_READ: 'premium:reports:read',
  PREMIUM_REPORTS_EXPORT: 'premium:reports:export',
});
